<template>
  <div class="shouyeLineEchart" style="background: #fff; margin-top: 10px;padding-bottom:10px;">
    <div :id="id" class="echarts"></div>
  </div>
</template>
<script>
import echartsMixins from "@/assets/js/echartsMixins.js"

export default {
  props: ['id', 'ehartData', 'ehartData2'],
  mixins: [echartsMixins],

  data() {
    return {
      myChart: '',
    }
  },
  watch: {
    ehartData: {
      handler(newVal, oldVal) {
        this.initEcharts()

      },
      deep: true,
    },
  },
  mounted() {
    this.myChart = this.$echarts.init(document.getElementById(this.id))
    this.initEcharts()
  },
  methods: {
    // 刷新组件
    handlerResize(){
      this.myChart.resize()
    },
    initEcharts() {
      var option = {
        title: {
          top: '4%',
          left: '1%',
          bottom: '15%',
          text: '近一年参与培训人数及通过考核人数趋势图',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
          },
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        legend: {
          data: ['培训人数', '通过考核人数', '一次性通过率'],
          bottom:0,
        },
        grid: {
          top: '16%',
          left: '2%',
          right: '2%',
          bottom: '5%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: this.ehartData.x,
            triggerEvent: true,

            // 刻度线
            axisTick: {
              show: true,
            },
            // axisLabel: {
            //   interval: 0,
            //   rotate: 30
            // },
            //  轴线
            axisLine: {
              lineStyle: {
                color: '#ADB3BE',
              },
            },
            //  字体颜色和大小
            axisLabel: {
              interval: 0,
              rotate: 60,
              textStyle: {
                color: '#9AA1A9',
                fontSize: '14',
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            minInterval: 1,
            position: 'left',
            //  轴线
            axisLine: { show: true },
            // 刻度线
            axisTick: {
              show: false,
            },
            // 网格线
            splitLine: {
              show: true,
              lineStyle: {
                //  轴线颜色
                width: 0.5,
                color: ['#999999'],
                type: 'dashed',
              },
            },
            // 字体颜色和大小
            axisLabel: {
              textStyle: {
                color: '#9AA1A9',
                fontSize: '14',
              },
              formatter: '{value}',
            },
          },
          {
            type: 'value',
            minInterval: 1,
            min: 0, // 设置最小刻度
            max: 100, // 设置最大刻度
            position: 'right',
            alignTicks: true,
            //  轴线
            axisLine: {
              show: true,
              lineStyle: {
              }
            },

            // 刻度线
            axisTick: {
              show: true,
            },
            // 网格线
            splitLine: {
              show: true,
              lineStyle: {
                //  轴线颜色
                width: 0.5,
                color: ['#999999'],
                type: 'dashed',
              },
            },
            // 字体颜色和大小
            axisLabel: {
              textStyle: {
                color: '#9AA1A9',
                fontSize: '14',
              },
              formatter: function(value) {
                return Math.floor(value);
              }
            },
          },
        ],
        series: [
          {
            name: '培训人数',
            type: 'bar',
            barWidth: '30%',
            label: {
              show: true,
              precision: 1,
              fontWeight: 'bold',
              position: 'top',
              valueAnimation: true,
              fontFamily: 'monospace',
              color: '#5087EC',
            },
            yAxisIndex: 0, // 关键！指向第二个Y轴
            color: '#5087EC',
            data: this.ehartData.training,
          },
          {
            name: '通过考核人数',
            type: 'bar',
            barWidth: '30%',
            label: {
              show: true,
              precision: 1,
              fontWeight: 'bold',
              position: 'top',
              valueAnimation: true,
              fontFamily: 'monospace',
              color: '#68BBC4',
            },
            yAxisIndex: 0, // 关键！指向第二个Y轴
            color: '#68BBC4',
            data: this.ehartData.exam,
          },
          {
            name: '一次性通过率',
            type: 'line',
            barWidth: '30%',
            label: {
              show: true,
              precision: 1,
              fontWeight: 'bold',
              position: 'top',
              valueAnimation: true,
              fontFamily: 'monospace',
              color: '#59A55C',
            },
            yAxisIndex: 1, // 关键！指向第二个Y轴
            color: '#59A55C',
            data: this.ehartData.rate,
          },

        ],
      }
      this.myChart.setOption(option)
    },
  },
}
</script>
<style lang="scss" scoped>
.shouyeLineEchart {
  width: 100%;
  position: relative;
  .dw {
    font-size: 14px;
    color: #999999;
    position: absolute;
    right: 20px;
    top: 23px;
  }
  .echarts {
    width: 100%;
    height: px(420);
  }
}
</style>
